<span [class]="badgeClass()">
    {{ usedKbItem().entity1 }} {{ relationSymbol() }} {{ usedKbItem().entity2 }}
</span>
